import { ServerError } from '../errors';
import { isFormData } from '../polyfill';
import { isString } from '../utils';
import { APIError } from './APIError';
import { FETCH_FLAG } from './constants';
export class APIClient {
    _env;
    _requestInterceptor;
    constructor(env) {
        this._env = env;
    }
    get apiURL() {
        return `${this._env.baseURL}${this._env.apiPrefix}`;
    }
    get env() {
        return this._env;
    }
    set requestInterceptor(value) {
        if (isString(value)) {
            this._requestInterceptor = eval(value);
        }
        else {
            this._requestInterceptor = value;
        }
    }
    async get(path, data, headers) {
        return this._request('GET', path, data, headers);
    }
    async post(path, data, headers) {
        return this._request('POST', path, data, headers);
    }
    async _request(method, path, data, headers) {
        let config = { path, headers };
        if (this._requestInterceptor) {
            try {
                config = this._requestInterceptor(path, headers);
            }
            catch { }
        }
        const isPost = method === 'POST';
        const url = this._makeURL(config.path);
        if (method === 'GET') {
            if (data) {
                for (const [key, value] of Object.entries(data)) {
                    if (value !== undefined && value !== null) {
                        let stringValue;
                        if (value instanceof Date) {
                            stringValue = value.toISOString();
                        }
                        else {
                            stringValue = value.toString();
                        }
                        url.searchParams.set(key, stringValue);
                    }
                }
            }
        }
        const defaultHeaders = {};
        let body = undefined;
        if (isPost) {
            if (isFormData(data)) {
                body = data;
            }
            else {
                body = JSON.stringify(data);
                defaultHeaders['Content-Type'] = 'application/json';
            }
        }
        const promise = fetch(url.href, {
            method,
            mode: 'cors',
            body: body,
            headers: { ...defaultHeaders, ...(this._env.headers || {}), ...(config.headers || {}) },
            [FETCH_FLAG]: true,
        });
        return this._dealWithResponse(config.path, promise);
    }
    async _dealWithResponse(path, promise) {
        let httpResponse;
        try {
            httpResponse = await promise;
        }
        catch (e) {
            throw new ServerError(`Error occurs when invoking API "${path}": ${e.message}`, { cause: e });
        }
        let res;
        try {
            res = await httpResponse.json();
        }
        catch (e) {
            throw new ServerError(`Response of API "${path}" can not be parsed into JSON.`, { cause: e });
        }
        if (res.success) {
            return res.data;
        }
        else {
            throw new APIError(path, res.code, res.message);
        }
    }
    _makeURL(path) {
        return new URL(path, this.apiURL);
    }
}
